// extracted by mini-css-extract-plugin
module.exports = {"bar":"TasksFilterBar_legacy_bar__ki_W_"};